import React from 'react';
import { ContentsSettingDataResponse } from '@display-component/shared';
import { displayServiceServerGateway } from '@display-component/pc';
import dynamic from 'next/dynamic';
import { wrapper } from '@/redux/store';
import { NextSeo } from 'next-seo';
import { AgentWithAgency } from '@remodeling/shop';
import { expertGateway } from '@/di-container/expert/detail/gateway/server';
import AppLayout from '@/components/AppLayout';
import { axios } from '@/di-container/axios';
import { FloatingGroup } from '@/components/FloatingGroup';
import TrackingService from '@/services/tracking';

export interface ExpertDetailPageProps {
  detailData: AgentWithAgency;
  constructionCaseData: ContentsSettingDataResponse[] | [];
}

const ExpertDetail = dynamic(() =>
  import('@/feat-components/ExpertDetail').then((mod) => mod.ExpertDetail),
);

const ExpertDetailPage = (props: ExpertDetailPageProps) => {
  return (
    <>
      <NextSeo
        noindex={process.env.NEXT_PUBLIC_STAGE !== 'production'}
        nofollow={process.env.NEXT_PUBLIC_STAGE !== 'production'}
      />
      <AppLayout
        layoutType="full"
        isGnbExist={false}
        floatingArea={
          <FloatingGroup
            onlyTopButton={true}
            {...TrackingService.tagGTM('expert_detail_top_button', {
              'expert-id': props?.detailData?.agentDetail?.code,
            })}
          />
        }
        content={
          <ExpertDetail
            detailData={props?.detailData}
            constructionCaseData={props.constructionCaseData}
          />
        }
      />
    </>
  );
};

export default ExpertDetailPage;

export const getServerSideProps = wrapper.getServerSideProps(
  () =>
    async ({ query: { id }, req }) => {
      const apiResponse = await expertGateway().getExpertDetail.exec({
        agentCode: id as string,
      });

      if (apiResponse.code !== 200) {
        return {
          redirect: {
            destination: `/not-exists-content`,
            permanent: false,
          },
        };
      }

      let detailData: AgentWithAgency | {} = {};

      if (apiResponse.code === 200 && apiResponse.data) {
        detailData = apiResponse.data;
      }

      const displayComponentResponse = await displayServiceServerGateway(
        process.env.NEXT_PUBLIC_BASE_API_URL || '',
        axios,
      ).getTemplateComponents.exec(
        {
          rdId: id as string,
        },
        req.headers.cookie || '',
      );

      let constructionCaseData: ContentsSettingDataResponse[] | [] = [];

      if (
        displayComponentResponse?.code === 200 &&
        displayComponentResponse?.data?.[0]?.data?.content
      ) {
        constructionCaseData = displayComponentResponse?.data?.[0]?.data
          ?.content as ContentsSettingDataResponse[];
      }

      return {
        props: {
          detailData,
          constructionCaseData,
        },
      };
    },
);
